// Converts a normal Google Drive "share" link into a direct-viewable image URL.
// Accepts links like:
//   https://drive.google.com/file/d/FILE_ID/view?usp=sharing
//   https://drive.google.com/open?id=FILE_ID
//   https://drive.google.com/uc?id=FILE_ID
// Also passes through any non-Drive URL (e.g. a normal https image link) unchanged.
export function toDirectImageUrl(url) {
  if (!url) return ''
  const trimmed = url.trim()

  if (!trimmed.includes('drive.google.com')) {
    return trimmed
  }

  let fileId = ''

  const fileMatch = trimmed.match(/\/file\/d\/([^/]+)/)
  if (fileMatch) {
    fileId = fileMatch[1]
  } else {
    const idMatch = trimmed.match(/[?&]id=([^&]+)/)
    if (idMatch) {
      fileId = idMatch[1]
    }
  }

  if (!fileId) return trimmed

  return `https://drive.google.com/uc?export=view&id=${fileId}`
}
